import FormsActions from "@/components/forms/FormsActions";
import {executeAction} from "@/components/dashboard/SmartActions";
import ActivityManager from "@/activity/ActivityManager";

export default class RemoteActions{
    constructor() {
    }

    /**
     * @param {OutputMessage} outputMessage
     */
    async process(outputMessage){
        let actions = outputMessage.frontendActions;
        if(!actions){
            return;
        }
        for(const a of actions){
            await this.executeAction(a);
        }
    }

    async executeAction(action){
        switch(action['type']){
            case "smartSearchAction":
                return await this.runSmartSearchAction(action)
            case "consoleLog":
                console.log(action['message']);
                return;
            case "showDialog":
                return await this.showDialog(action);
            case "showList":
                return await this.showList(action);
            case "editEntity":
                return await this.editEntity(action);
        }//tutaj zaimplementowac
    }

    async showList(action){
        return FormsActions.showList(action['clazz'], {});
    }

    async showDialog(action){
        return DialogManager.info(action['title'], action['message']);
    }

    async editEntity(action){
        await ActivityManager.closeAll()
        return FormsActions.editEntity(action['clazz'], action['entityId']);
    }

    async runSmartSearchAction(action){
        return executeAction(action['actionCall']);
    }

}